<template>
  <div class="vue-webuploader-com">
    <slot>
      <div :id="id" v-if="!btnId || btnId.length === 0"></div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'VueWebuploader',
  props: {
    // webuploader 参数
    options: {
      type: Object,
      default () {
        return {};
      },
    },
    // 是否自动初始化
    autoInit: {
      type: Boolean,
      default: true,
    },
    // 选择文件按钮id
    btnId: {
      type: String,
      default: '',
    },
    // swf路径
    swf: {
      type: String,
      default: '',
    },
  },
  data () {
    let id = 'uploadID_' + new Date().getTime() + Math.random().toString(32).substr(2);
    let btnId = this.btnId || id;
    return {
      id: id,
      // webuploader 对象
      uploader: null,
      // webuploader初始化默认参数
      defaultOptions: {
        // swf目录，这里引用cdn的
        swf: 'http://cdn.staticfile.org/webuploader/0.1.0/Uploader.swf',
        pick: {
          id: ('#' + btnId),
          innerHTML: '选择文件',
        },
        compress: false,
        // 限制单个文件最大体积，默认5M
        fileSingleSizeLimit: 5242880,
      },
      // 存储选择的文件
      files: [],
      // 当前uploader是否已经初始化
      _hasInit: false,
    };
  },
  methods: {
    // 当文件被加入队列之前触发，此事件的handler返回值为false，则此文件不会被添加进入队列。
    _beforeFileQueued (file) {

    },
    // 当文件被加入队列以后触发
    _fileQueued (file) {
      let _that = this;
      this._WuFileBindStatusChangeEvent(file);
      if (/image\//.test(file.type)) {
        this.uploader.makeThumb(file, function (error, ret) {
          if (error) {
            console.error('预览错误', error);
            _that.files.push(file);
          } else {
            file.previewData = ret;
            _that.files.push(file);
          }
          _that.$emit('fileChange', _that.files);
          _that.$emit('fileQueued', file);
        }, 1, 1);
      } else {
        _that.files.push(file);
        _that.$emit('fileChange', _that.files);
        _that.$emit('fileQueued', file);
      }
    },
    // 当文件被移除队列后触发。
    _fileDequeued (file) {
      let _that = this;
      let id = file.id;
      let index = this.getIndex(this.files, function (item) {
        return item.id === id || item.file.id === id;
      });
      this.files.splice(index, 1);
      _that.$emit('fileChange', _that.files);
    },
    // 文件上传前触发
    _uploadBeforeSend (block, data, header) {
      /* block为分块数据。// file为分块对应的file对象。var file = block.file;修改data可以控制发送哪些携带数据。
            默认会传递当前这张图的旋转角度 */
      // 将存在file对象中的md5数据携带发送过去。// data.fileMd5 = file.md5;// 删除其他数据// delete data.key;
      let _that = this;
      let currentFileDatas = block.file.datas;
      let _fn = function (attr, val) {
        data[attr] = val;
      };
      if (currentFileDatas && $.isPlainObject(currentFileDatas)) {
        $.each(currentFileDatas, _fn);
      }
      // 添加自定义header
      if (_that.getOptions.header && $.isPlainObject(_that.getOptions.header)) {
        $.extend(true, header, _that.getOptions.header);
      }
    },
    _uploadProgress (file, percentage) {
      this.$emit('uploadProgress', file, percentage);
    },
    // 文件上传成功后触发
    _uploadSuccess (file, res) {
      this.$emit('uploadSuccess', file, res);
    },
    // 当某个文件上传到服务端响应后，会派送此事件来询问服务端响应是否有效。如果此事件handler返回值为false, 则此文件将派送server类型的uploadError事件。
    _uploadAccept (object, res) {
      this.$emit('uploadAccept', object, res);
      // return false;
    },
    // 文件上传失败时触发
    _uploadError (file, reason) {
      this.$emit('uploadError', file, reason);
    },
    // 当文件校验不通过时触发
    _error (type) {
      this.$emit('error', type);
    },
    // 给添加到队列中的文件绑定 statuschange 事件
    _WuFileBindStatusChangeEvent (file) {
      file.on('statuschange', function (currentState, prev) {
        /* 文件状态值，具体包括以下几种类型：
              inited 初始状态
              queued 已经进入队列, 等待上传
              progress 上传中
              complete 上传完成。
              error 上传出错，可重试
              interrupt 上传中断，可续传。
              invalid 文件不合格，不能重试上传。会自动从队列中移除。
              cancelled 文件被移除。 */
        this.currentStatus = currentState;
      });
    },
    // 获取数组中符合条件的元素的索引
    getIndex (arr, fn) {
      if (!arr || arr.length === 0 || !fn || (typeof fn !== 'function')) {
        return -1;
      }

      if (arr.findIndex) {
        return arr.findIndex(fn);
      }
      let len = arr.length;
      let i = 0;
      let index = -1;
      for (; i < len; i++) {
        let item = arr[i];
        if (fn(item, index, arr) === true) {
          index = i;
          break;
        }
      }
      return index;
    },
    // 给文件添加额外数据
    addData (file, data) {
      if (!file || ($.type(file) === 'object' && !file.id)) {
        console.error('addData(file,data)的file参数须为file id或file对象');
        return;
      }
      if ($.type(data) !== 'object') {
        console.error('addData(file,data)的data参数须为一个对象');
        return;
      }
      let realFile = null;
      if ($.type(file) === 'string') {
        realFile = this.uploader.getFile(file);
      } else {
        realFile = this.uploader.getFile(file.id);
      }
      if (!realFile) {
        realFile = file;
      }
      if (!realFile.datas) {
        realFile.datas = data;
      } else {
        $.extend(true, realFile.datas, data);
      }
      realFile = null;
    },
    // 删除文件
    removeFile (fileOrId) {
      if (!fileOrId || ($.type(fileOrId) === 'object' && !fileOrId.id)) {
        console.error('removeFile(fileOrId)的fileOrId参数须为file id或file对象');
        return;
      }
      let uploader = this.uploader;
      let file = null;
      if ($.type(fileOrId) === 'string') {
        file = uploader.getFile(fileOrId);
      } else {
        file = fileOrId;
      }

      uploader.removeFile(file);
      file = null;
    },
    // 开始上传
    upload (file) {
      if (file) {
        this.uploader.upload(file);
      } else {
        this.uploader.upload();
      }
    },
    // 暂停上传
    stop () {
      this.uploader.stop();
    },
    // 重试上传
    retry (file) {
      if (file) {
        this.uploader.retry(file);
      } else {
        this.uploader.retry();
      }
    },
    // 禁用按钮
    disable () {
      this.uploader.disable();
    },
    // 启用按钮
    enable () {
      this.uploader.enable();
    },
    // 刷新按钮
    refresh () {
      this.uploader.refresh();
    },
    // 初始化webuploader
    init () {
      this.$nextTick(() => {
        let _that = this;
        let uploader;
        let events;
        if (!window.WebUploader) {
          let timer = setInterval(() => {
            if (window.WebUploader) {
              clearInterval(timer);
              this.init();
            }
          }, 200);
          return;
        }
        if (this._hasInit) {
          return;
        }
        this._hasInit = true;
        uploader = window.WebUploader.create(this.getOptions);
        events = ['beforeFileQueued', 'fileQueued', 'filesQueued', 'fileDequeued',
          'reset', 'startUpload', 'stopUpload', 'uploadFinished', 'uploadStart',
          'uploadBeforeSend', 'uploadAccept', 'uploadProgress', 'uploadError', 'uploadSuccess',
          'uploadComplete', 'error'];

        // 给webuploader批量绑定事件
        $.each(events, function (index, item) {
          var eventFnName = '_' + item;
          if (_that[eventFnName] && (typeof _that[eventFnName] === 'function')) {
            uploader.on(item, _that[eventFnName]);
          }
        });
        this.uploader = uploader;
      });
    },
  },
  computed: {
    // 获取配置参数
    getOptions () {
      if (window.$) {
        return $.extend(true, {}, this.defaultOptions, this.options);
      } else {
        return this.defaultOptions;
      }
    },
  },
  watch: {
    options: {
      // options改变时修改uploader的参数
      handler () {
        let options = this.getOptions;
        let uploader = this.uploader;

        if (uploader) {
          for (let attr in options) {
            uploader.option(attr, options[attr]);
          }
        }
      },
      deep: true,
    },
  },
  created () {
    let _that = this;
    let swfEle = document.getElementById('swf_url');
    let webUploaderEle = document.getElementById('webuploader_url');
    let swfUrl = '';
    let webuploaderUrl = '';

    if (!webUploaderEle) {
      console.error('未能找到id=webuploader_url的a元素，并且它的href必须是webuploader.js的路径！');
    }

    let cdnUrl = 'http://cdn.staticfile.org/webuploader/0.1.0/webuploader.min.js';
    webuploaderUrl = webUploaderEle ? webUploaderEle.href : cdnUrl;

    if (this.swf) {
      this.defaultOptions.swf = this.swf;
    } else if (swfEle) {
      console.error('未能找到id=swf_url的a元素！');
      swfUrl = swfEle ? swfEle.href : '';
      this.defaultOptions.swf = swfUrl;
    }
    if (!window.WebUploader && !window._webuploaderLoadStart) {
      let script = document.createElement('script');
      window._webuploaderLoadStart = true;
      script.onload = script.onreadystatechange = function () {
        if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
          if (_that.autoInit) {
            _that.init();
          }
          script.onload = null;
          document.head.removeChild(script);
          script = null;
        }
      };
      script.src = webuploaderUrl;
      document.head.appendChild(script);
    }
  },
  mounted () {
    if (this.autoInit) {
      this.init();
    }
  },
  beforeDestroy () {
    try {
      if (this.uploader) {
        this.uploader.destroy();
      }
    } catch (e) {
      console.error(e);
    }
  },
};
</script>

<style>
  @import "webuploader.css";
</style>
